import api from "@/lib/api";

/**
 * Poll a job until SUCCESS or FAILED.
 * @param {string} jobId
 * @param {object} opts
 * @param {function} opts.onProgress - called every poll with the job doc
 * @param {number} opts.intervalMs - poll interval (default 2000)
 * @param {number} opts.timeoutMs - hard timeout (default 5 minutes)
 * @returns {Promise<object>} - the final job doc
 */
export async function pollJob(jobId, opts = {}) {
  const { onProgress, intervalMs = 2000, timeoutMs = 5 * 60 * 1000 } = opts;
  const start = Date.now();
  // eslint-disable-next-line no-constant-condition
  while (true) {
    if (Date.now() - start > timeoutMs) {
      throw new Error("Job timed out after " + Math.round(timeoutMs / 1000) + "s");
    }
    let job;
    try {
      const r = await api.get(`/jobs/${jobId}`);
      job = r.data;
    } catch (e) {
      throw new Error("Failed to fetch job status: " + (e?.response?.data?.detail || e.message));
    }
    if (onProgress) onProgress(job);
    if (job.status === "SUCCESS" || job.status === "FAILED") {
      return job;
    }
    // eslint-disable-next-line no-await-in-loop
    await new Promise((res) => setTimeout(res, intervalMs));
  }
}
